
























































































































import { PropType } from 'vue';
import { mapActions } from 'vuex';
import { get } from 'vuex-pathify';

// utilities
import mixins, { ExtractVue } from '@/utils/mixins';

// mixins
import componentState from '@/mixins/state';

import { Module, ModulePaymentTypeEnum } from '@/models/configurator/module';
import { QuoteProductItem, QuoteProductCategory, Quote } from '@/models/quote';
import QuoteProductCustomDiscountsDialog from '@/components/quotes/QuoteProductCustomDiscountsDialog.vue';
import { ErrorManager } from '@/models/error';
import { AxiosError } from 'axios';

export default mixins(componentState).extend({
  name: 'QUoteProductItemRow',

  components: { QuoteProductCustomDiscountsDialog },

  props: {
    quote: Object as PropType<Quote>,
    quoteProductCategory: Object as PropType<QuoteProductCategory>,
    items: Array as PropType<QuoteProductItem[]>,
    editable: Boolean,
    subscription: Boolean,
    exchangeRate: Number,
    currencyCode: String,
    expand: Boolean
  },
  data: () => ({
    percentageValue: 0,
    usePercentageItemDiscount: false,

    applyFirstYearDiscountPercentageLoading: false,

    errorMessage: ''
  }),
  computed: {
    expanded: {
      get(): boolean {
        return this.expand;
      },
      set(val: boolean): void {
        this.$emit('update:expand', val);
      }
    } as any,
    getModuleById: get<(id: number) => Module>(
      'configuratorModule/getModuleById'
    ),
    jcmiIcon: get('app/miniCompanyImage'),
    currentModule(): Module | undefined {
      return this.getModuleById(Number(this.quoteProductCategory.module));
    },

    isCurrentModulePaymentTypeRecurring(): boolean {
      return !!(
        this.currentModule &&
        this.currentModule.payment_type == ModulePaymentTypeEnum.Recurring
      );
    },

    configurationName(): string {
      if (this.quoteProductCategory) {
        let name = String(this.quoteProductCategory.module);
        try {
          if (this.currentModule) {
            name = this.getModuleById(Number(this.quoteProductCategory.module))
              .name!;
          } else {
            this.fetchModule(this.quoteProductCategory.module).then(
              (result: Module) => {
                name = result.name!;
              }
            );
          }
        } catch (err) {
          this.setComponentState('error', err);
        }
        return name;
      }
      return '';
    },
    configurationIcon(): string {
      return this.jcmiIcon;
    },

    isConfigurationModuleArchived(): boolean {
      const module = this.getModuleById(this.quoteProductCategory.module);

      return !!module.is_archived;
    },

    configurationPrice(): number {
      return this.quoteProductCategory.price;
    },
    discountPercentage(): number {
      return (
        (this.quoteProductCategory.discount! / this.configurationPrice) * 100 ||
        0
      );
    },
    snapshot(): number | undefined {
      return this.quote.customer?.contract?.snapshot;
    }
  },

  methods: {
    ...mapActions({
      fetchModules: 'configuratorModule/fetchModules',
      fetchModule: 'configuratorModule/fetchModule',
      applyFirstYearSubscriptionDiscountPercentage:
        'quote/applyFirstYearSubscriptionDiscountPercentage'
    }),

    async openCustomItemDialog() {
      const { default: productCustomDiscountsDialog } = await import(
        '@/components/quotes/QuoteProductCustomDiscountsDialog.vue'
      );
      if (productCustomDiscountsDialog) {
        const formDialog = this.$refs
          .quoteProductCustomDiscountsDialog as ExtractVue<
          typeof productCustomDiscountsDialog
        >;
        formDialog.open(
          this.quoteProductCategory,
          this.exchangeRate,
          this.currencyCode,
          this.snapshot
        );
      }
    },

    updateFirstYearDiscount(discountPercentage: number) {
      // LH - 2023-10-13 - Intnetionally setting the percentage field not risk contrusting a new Quote Product Category instance
      this.quoteProductCategory.first_year_subscription_discount_percentage = discountPercentage;

      this.$emit('update:quote-product-category', this.quoteProductCategory);
    },

    updateDiscount(discount: number) {
      const updatedDiscountedProductCategory = Object.assign(
        this.quoteProductCategory,
        { discount }
      );
      this.$emit(
        'update:quote-product-category',
        updatedDiscountedProductCategory
      );
    },

    updatePrice(price: number) {
      const updatedDiscountedProductCategory = Object.assign(
        this.quoteProductCategory,
        { price: price * this.exchangeRate }
      );
      this.$emit(
        'update:quote-product-category',
        updatedDiscountedProductCategory
      );
    },

    openCustomDiscounts() {
      this.$emit('openCustomDiscounts', {
        module: this.quoteProductCategory.module,
        item: this.items
      });
    },

    clearAllErrors() {
      this.errorMessage = '';
    },

    async applyFirstYearDiscount(discount: number) {
      this.clearAllErrors();
      this.applyFirstYearDiscountPercentageLoading = true;

      try {
        await this.applyFirstYearSubscriptionDiscountPercentage({
          id: this.quote.number,
          revision: this.quote.revision,
          category: this.quoteProductCategory.id,
          first_year_subscription_discount_percentage: discount
        });
        this.updateFirstYearDiscount(discount);
      } catch (err) {
        const error = err as AxiosError;
        if (error.response && error.response.data.detail) {
          this.errorMessage = error.response.data.detail;
        } else {
          this.errorMessage = ErrorManager.extractApiError(error);
        }
      } finally {
        this.applyFirstYearDiscountPercentageLoading = false;
      }
    }
  }
});
